/**
 * Role-aware navigation targets shared by the 403 page, account pages'
 * back navigation, and anywhere else that needs a deterministic "home".
 */

/**
 * Home path for the current role. SuperAdmin outside merchant mode lives in
 * the admin area; everyone else lands on the merchant list (/merchants
 * redirects to /merchants/list, and the workspace guard takes over from there).
 */
export function getRoleHomePath(
  role?: string,
  inMerchantMode?: boolean,
): string {
  if (role === 'SuperAdmin' && !inMerchantMode) {
    return '/admin/merchant-owners';
  }
  return '/merchants';
}
